import * as React from 'react';
import { HeroBannerWithCTAButtons } from './HeroBannerWithCTAButtons';
import { CTAButton, DYCustomizableText, DyImages } from '../types/types';
import { transformDYTemplateVariables } from './utils';

export interface DYHeroBannerWithCTAButtonsTemplateVariables {
  onClick: VoidFunction;
  data: {
    title?: DYCustomizableText;
    subtitle?: DYCustomizableText;
    ctas: CTAButton[];
    ctaType: string;
    images: DyImages;
  };
}

/** This is basically our adaptor. It converts the template-variables defined via the dynamic yield ui */
export const DYHeroBannerWithCTAButtons: React.FC<DYHeroBannerWithCTAButtonsTemplateVariables> = ({
  data,
  onClick,
}) => {
  const props = transformDYTemplateVariables(data);
  return <HeroBannerWithCTAButtons {...props} onClick={onClick}></HeroBannerWithCTAButtons>;
};
